import { trpc } from "../trpc";

export function useCreateFolderShares() {
  const utils = trpc.useUtils();

  const { mutate, isPending } = trpc.folder.createShares.useMutation({
    onMutate: ({ folderId }) => {
      // Cancel any outstanding queries so things are overwritten
      utils.folder.folderShares.cancel({ folderId });
    },
    onSettled: (_, __, { folderId }) => {
      // Refetch the queries to get fresh data
      utils.folder.folderShares.invalidate({ folderId });
    },
  });

  return {
    createFolderShares: mutate,
    isLoading: isPending,
  };
}
